import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
    <div class="card" style="margin-bottom:10px;">
      <h3 class="card-header">{{ field.templateOptions.label }}</h3>
      <div class="card-body" style="border-left: 1px solid #c1c1c1;padding-left: 10px;">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
})
export class PanelWrapperComponent extends FieldWrapper {}
